import { FC } from 'react';

import { IcBackIcon, IcDoneIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';

import { ITextFormattingMenuViewParams } from '../TextFormattingMenu.types';
import { TextFormattingMenuButton } from '../components/TextFormattingMenuButton/TextFormattingMenuButton';
import { TextFormattingMenuInput } from '../components/TextFormattingMenuInput/TextFormattingMenuInput';
import { useTextFormattingLinkViewPresenter } from './TextFormattingLinkView.presenter';
import styles from './TextFormattingLinkView.styles.m.css';

type ITextFormattingLinkViewProps = ITextFormattingMenuViewParams;

export const TextFormattingLinkView: FC<ITextFormattingLinkViewProps> = (props) => {
  const { t } = useTranslation();
  const presenter = useTextFormattingLinkViewPresenter(props);

  return (
    <>
      <AddKeyPressHandler
        isCaptured
        onEnter={presenter.onEnterKey}
      />

      <TextFormattingMenuButton
        theme={'1'}
        Icon={IcBackIcon}
        onClick={presenter.onBack}
      />
      <TextFormattingMenuInput
        className={styles.input}
        value={presenter.link}
        placeholder={t('paste_or_type')}
        onChange={presenter.onLinkChange}
      />
      <div className={styles.divider} />
      <TextFormattingMenuButton
        theme={'3'}
        Icon={IcDoneIcon}
        isDisabled={!presenter.canSubmit}
        onClick={presenter.onSubmit}
      />
    </>
  );
};
